import ApiRequestBuilder from '../ApiService/Request/ApiRequestBuilder';


const API_PATH_ORDERS_BASE = '/orders';

const API_PATH_ORDERS = `${API_PATH_ORDERS_BASE}`;
const API_PATH_ORDER_DETAILS = `${API_PATH_ORDERS_BASE}/:orderId`;
const API_PATH_ORDER_DOWNLOAD_CONTENTS = `${API_PATH_ORDERS_BASE}/:orderId/download/content`;
const API_PATH_ORDER_SUMMARY = `${API_PATH_ORDERS_BASE}/:orderId/summary`;

const API_PATH_ORDERS_SUBMIT = `${API_PATH_ORDERS}/submit`;
const API_PATH_ORDERS_SUBMIT_CART = `${API_PATH_ORDERS_SUBMIT}/cart/:cartId`;

const API_PATH_ORDER_PAYMENT = `${API_PATH_ORDERS_BASE}/:orderId/payment`;


class OrderService {

    /**
     * @type {ApiService}
     */
    apiService;


    /**
     * @param apiService {ApiService}
     */
    constructor(apiService) {

        this.apiService = apiService;
    }


    /**
     * @param cartId {string} Id of the cart to create an order for
     * @return {Promise<ApiResponse>} API response from submission request; 409 is failed validations
     */
    async submitCart(cartId) {

        const createOrderFromCartRequest = ApiRequestBuilder.post(API_PATH_ORDERS_SUBMIT_CART)
            .pathParams({cartId})
            .json()
            .withToken()
            .build();

        return this.apiService.execute(createOrderFromCartRequest);
    }


    /**
     * @param orderId {string} Id of the order to load
     * @return {Promise<object>} Order details
     */
    async getOrder(orderId) {

        const orderDetailsRequest = ApiRequestBuilder.get(API_PATH_ORDER_DETAILS)
            .pathParams({orderId})
            .json()
            .withToken()
            .build();

        return this.apiService.executeOrFail(orderDetailsRequest, 'Error loading order details');
    }


    /**
     * @param orderId {string} Id of the order summary to load
     * @return {Promise<object>} Order summary
     */
    async getOrderSummary(orderId) {

        const orderSummaryRequest = ApiRequestBuilder.get(API_PATH_ORDER_SUMMARY)
            .pathParams({orderId})
            .json()
            .withToken()
            .build();

        return this.apiService.executeOrFail(orderSummaryRequest, 'Error loading order summary');
    }


    /**
     * @param orderId {string} Id of the order to process payment for
     * @return {Promise<ApiResponse>} Order payment response
     */
    async initializeOrderPayment(orderId) {

        const orderPaymentRequest = ApiRequestBuilder.post(API_PATH_ORDER_PAYMENT)
            .pathParams({orderId})
            .json()
            .withToken()
            .build();

        return this.apiService.execute(orderPaymentRequest);
    }


    /**
     * @param orderId {string} Id of the order to process payment for
     * @return {Promise<ApiResponse>} Order payment response
     */
    async processOrderPayment(orderId) {

        const orderPaymentRequest = ApiRequestBuilder.put(API_PATH_ORDER_PAYMENT)
            .pathParams({orderId})
            .json()
            .withToken()
            .build();

        return this.apiService.execute(orderPaymentRequest);
    }


    /**
     * @param orderId {string} Order id to download contents for
     * @return {ApiRequest} Download order contents API request
     */
    createOrderDownloadRequest(orderId) {

        return ApiRequestBuilder.get(API_PATH_ORDER_DOWNLOAD_CONTENTS)
            .pathParams({orderId})
            .withToken()
            .build();
    }
}

export default OrderService;
